export function UnitCount(props: { count: number }) {
  if (props.count > 1) {
    return <span style={{ opacity: 0.5 }}> (x{props.count})</span>;
  }

  return null;
}
